var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAb2998(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#6A6B6C;stroke-width:12.3364;stroke-miterlimit:10;}\r\n\t.st1{fill:#6A6B6C;}\r\n\t.st2{font-family:'GillSans';}\r\n\t.st3{font-size:39.6523px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.3,50.8c21.7,39.4,7.3,88.9-32.1,110.7c-39.4,21.6-88.9,7.3-110.6-32.1S11.3,40.4,50.7,18.7 C90.1-3,139.7,11.3,161.3,50.8z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 41.4142 80.6124)",
    className: "st1 st2 st3"
  }, "AB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 41.4142 128.1959)",
    className: "st1 st2 st3"
  }, "2998"), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.5,84.5c12.2-7.7,18.2-31.3,15.8-29.7c-10.1,6.9-20.2,0.8-28.4,5.1c-6.2,3.2-8.1,11.3-8.8,16.2 c0,0-4.6,1.1-10,0.9c-1.8-0.1-1.7,3.7-0.3,3.8c18.7,1.4,38-16.8,38-16.8s-7.6,16-25.6,20C109.1,85.7,116.6,90.1,125.5,84.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb2998);
export default __webpack_public_path__ + "static/media/AB-2998.19852fdb30a44a93e43d56a05b064d3c.svg";
export { ForwardRef as ReactComponent };